import { useNavigate } from 'react-router';
import Stack from '@mui/material/Stack';
import { JuicyTypography } from '../../components/index.ts';
import { RippleWaves } from '../../features/index.ts';
import { Path } from '../../assets/enums/index.ts';
import { useGameSessionContext } from '../../assets/helpers/hooks/index.ts';
import { stackSx, wrapperSx } from './styles.ts';
import { TimerIcon } from '../../assets/icons/timer.tsx';
import { PageBackButton } from '../../components/button/pageBackButton.tsx';
import { NextPageButton } from '../../components/button/NextPageButton.tsx';
import * as React from 'react';

export const BettingLimitPage = () => {
  const navigate = useNavigate();
  const { setParams } = useGameSessionContext();
  const onPlayForFreeButtonClick = () => {
    setParams({ isFreeTraining: true });
    navigate(Path.StartGame)
  };
  return (
    <Stack sx={wrapperSx}>
      <JuicyTypography>You've reached you betting limit for today...</JuicyTypography>

      <Stack
        sx={stackSx}>
        <TimerIcon />
        <RippleWaves width={480} height={480} />
      </Stack>



      <Stack width="100%" direction={'row'} alignItems={'center'} gap={8} mt={'auto'}>
        <PageBackButton onClick={() => navigate(Path.GameSettings)} />
        <NextPageButton onClick={onPlayForFreeButtonClick}>Play for free</NextPageButton>
      </Stack>
    </Stack>
  );
};
